module.exports = __webpack_public_path__ + "img/发布单笔询价@2x.04621a66.png";